const AREA_FIELD_KEYS = [
  'property_size_m2',
  'property_size_sqm',
  'propertySizeSqm',
  'area',
  'areaSize',
  'areaInSqm',
  'sqm',
  'propertySizeM2',
  'area_size',
  'area_sqm',
  'area_in_sqm',
];

const PUBLIC_AREA_FIELD_KEYS = AREA_FIELD_KEYS.flatMap(key => [key, `pub_${key}`]);

const hasValue = value =>
  value !== null &&
  typeof value !== 'undefined' &&
  !(typeof value === 'string' && value.trim() === '');

export const normalizeAreaSqmValue = value => {
  if (!hasValue(value)) return null;

  if (Array.isArray(value)) {
    const normalizedValue = value.map(normalizeAreaSqmValue).find(v => v !== null);
    return typeof normalizedValue === 'undefined' ? null : normalizedValue;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const normalizedString = value.trim().replace(/,/g, '');
    const numericValue = Number(normalizedString);
    if (Number.isFinite(numericValue)) return numericValue;

    // Backend/admin values can arrive with display units, e.g. "120 sqm" or "120 m2".
    const numericMatch = normalizedString.match(/-?\d+(?:\.\d+)?/);
    const valueWithUnit = numericMatch ? Number(numericMatch[0]) : NaN;
    return Number.isFinite(valueWithUnit) ? valueWithUnit : null;
  }

  if (typeof value === 'object') {
    const nestedValue = ['value', 'amount', 'number', 'content', 'label']
      .map(key => normalizeAreaSqmValue(value[key]))
      .find(v => v !== null);

    return typeof nestedValue === 'undefined' ? null : nestedValue;
  }

  return null;
};

const getNestedDataSources = data => {
  if (!data || typeof data !== 'object') return [];

  const attributes = data.attributes || {};
  return [
    attributes.publicData,
    attributes.publicData?.publicData,
    attributes.publicData?.data,
    attributes.metadata,
    data.publicData,
    data.publicData?.publicData,
    data.publicData?.data,
    data.data,
    data.metadata,
    data,
  ];
};

export const getListingAreaSqm = publicData => {
  const rawValue = getNestedDataSources(publicData)
    .flatMap(data => PUBLIC_AREA_FIELD_KEYS.map(key => data?.[key]))
    .find(hasValue);

  return normalizeAreaSqmValue(rawValue);
};
